"use strict";
/* tslint:disable:no-string-literal no-unsafe-any */
Object.defineProperty(exports, "__esModule", { value: true });
var simple_selector = /^[.#]?[\w-]*$/;
var isDocument = function (v) {
    return (v &&
        typeof v["createElement"] === "function" &&
        typeof v["getElementById"] === "function");
};
exports.querySelector = function (selector, context) {
    if (context === void 0) { context = document; }
    var is_simple = simple_selector.test(selector);
    if (is_simple) {
        if (selector[0] === "#") {
            var element = isDocument(context)
                ? context.getElementById(selector.slice(1))
                : document.getElementById(selector.slice(1));
            return element instanceof Element ? [element] : [];
        }
        if (selector[0] === ".") {
            return Array.prototype.slice.call(context.getElementsByClassName(selector.slice(1)));
        }
        return Array.prototype.slice.call(context.getElementsByTagName(selector));
    }
    return Array.prototype.slice.call(context.querySelectorAll(selector));
};
exports.querySelectorOne = function (selector, context) {
    if (context === void 0) { context = document; }
    var result = exports.querySelector(selector, context);
    return result.length > 0 ? result[0] : undefined;
};
exports.querySelectorForceOne = function (selector, context) {
    if (context === void 0) { context = document; }
    var result = exports.querySelector(selector, context);
    if (result.length === 0) {
        throw new ReferenceError("Cannot find element with selector \"" + selector + "\".");
    }
    return result[0];
};
